import { IconButton } from "@material-ui/core"
import { useDispatch } from "react-redux"
import ListIcon from '@material-ui/icons/List'
import { openCircuitoVueloAction } from "../../../ducks/proveedorAereolineaDuck"
const BCircuitoVuelo = (props) => {
    const { idVueloProveedor } = props
    const dispatch = useDispatch()
    const handleClick = () => {
        dispatch(openCircuitoVueloAction({
            vuelo: {
                IdVuelo: idVueloProveedor,
            }
        }))
    }
    return (
        <IconButton aria-label="Circuito vuelo" onClick={handleClick}>
            <ListIcon color="primary" />
        </IconButton>
    )
}
export default BCircuitoVuelo